import { basketResolvers } from "./resolvers/basket.js";
import { genericResolvers } from "./resolvers/generic.js";
import { handballResolvers } from "./resolvers/handball.js";
import { rugbyResolvers } from "./resolvers/rugby.js";
import { soccerResolvers } from "./resolvers/soccer.js";

export const globalResolvers = {
  ...genericResolvers,
  ...soccerResolvers,
  ...rugbyResolvers,
  ...handballResolvers,
  ...basketResolvers
}

export class GameFactEventFactory {
    static create(event) {
          const factory = globalResolvers[event.type]
          if (!factory) {
            throw new Error(`Unknown event type: ${event.type}`)
          }
          return factory(event)
        }
  }